import AnalysisModel from "./lab/AnalysisModel";
import AnalyteModel from "./lab/AnalyteModel";
import CustomerModel from "./crm/CustomerModel";
import CustomerContactModel from "./crm/CustomerContactModel";
import CustomerLocationModel from "./crm/CustomerLocationModel";
import CustomerGrowerModel from "./crm/CustomerGrowerModel";
import CustomerFieldModel from "./crm/CustomerFieldModel";
import InstrumentModel from "./lab/InstrumentModel";
import InstrumentInstanceModel from "./lab/InstrumentInstanceModel";
import LaboratoryModel from "./lab/LaboratoryModel";
import MeasureUnitModel from "./lab/MeasureUnitModel";
import PermissionModel from "./lab/PermissionModel";
import PrepProcessModel from "./lab/PrepProcessModel";
import PrepTaskModel from "./lab/PrepTaskModel";
import PrepWorkflowModel from "./lab/PrepWorkflowModel";
import ProjectModel from "./lab/ProjectModel";
import QualityControlModel from "./lab/QualityControlModel";
import ResultExportModel from "./lab/ResultExportModel";
import ResultModel from "./result/ResultModel";
import SampleModel from "./lab/SampleModel";
import SampleTypeModel from "./lab/SampleTypeModel";
import ScheduleModel from "./lab/ScheduleModel";
import StaffModel from "@/models/lab/StaffModel";
import SubmissionModel from "./lab/SubmissionModel";
import TestPackageModel from "./lab/TestPackageModel";
import TestPackageGroupModel from "./lab/TestPackageGroupModel";
import TestProcessModel from "./lab/TestProcessModel";
import TestTaskModel from "./lab/TestTaskModel";
import TestWorkflowModel from "./lab/TestWorkflowModel";
import TurnaroundModel from "./lab/TurnaroundModel";
import WorkGroupModel from "./lab/WorkGroupModel";
import UserModel from "./lab/UserModel";
import ManagedListModel from "./lab/ManagedListModel";
import ActivityModel from "./crm/ActivityModel";
import AnalyteResultModel from "./lab/AnalyteResultModel";
import AttributeListModel from "./lab/AttributeListModel";

const models = {
  activity: ActivityModel,
  analysis: AnalysisModel,
  analyte: AnalyteModel,
  analyte_result: AnalyteResultModel,
  attribute_list: AttributeListModel,
  customer: CustomerModel,
  customer_contact: CustomerContactModel,
  customer_location: CustomerLocationModel,
  customer_grower: CustomerGrowerModel,
  customer_field: CustomerFieldModel,
  instrument: InstrumentModel,
  instrument_instance: InstrumentInstanceModel,
  laboratory: LaboratoryModel,
  managed_list: ManagedListModel,
  measure_unit: MeasureUnitModel,
  permission: PermissionModel,
  prep_process: PrepProcessModel,
  prep_task: PrepTaskModel,
  prep_workflow: PrepWorkflowModel,
  project: ProjectModel,
  quality_control: QualityControlModel,
  resultExport: ResultExportModel,
  result: ResultModel,
  sample: SampleModel,
  sample_type: SampleTypeModel,
  schedule: ScheduleModel,
  staff: StaffModel,
  submission: SubmissionModel,
  test_package: TestPackageModel,
  test_package_group: TestPackageGroupModel,
  test_process: TestProcessModel,
  test_task: TestTaskModel,
  test_workflow: TestWorkflowModel,
  turnaround: TurnaroundModel,
  user: UserModel,
  work_group: WorkGroupModel,
};

export const ModelFactory = {
  get: name => models[name]
};
